import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';
import cn from 'classnames';

interface BackgroundWrapperProps
  extends HTMLAttributes<HTMLDivElement>,
    PropsWithChildren {
  wrapperClassName?: string;
}

const BackgroundWrapper = forwardRef<HTMLDivElement, BackgroundWrapperProps>(
  ({ wrapperClassName, children, ...props }, ref) => {
    return (
      <div ref={ref} {...props} className={cn('absolute', props.className)}>
        <div className={cn('relative w-full h-full', wrapperClassName)}>
          {children}
        </div>
      </div>
    );
  },
);

export { BackgroundWrapper };
